/**
 * TimelineTextRow — `timeline[row].text` / `timeline[column].text`
 * renderer. Paints a per-column text annotation from the parent
 * `(text, scalar)` source's cells (a cell write is the SDK row's).
 */
import type { Option } from "../../core/option.ts";
import type { NaiveDate } from "@tento-chrono";

import { RendererRow } from "./renderer-row.ts";
import { SourceCells } from "./source-cells.ts";
import { SourceRow } from "./source-row.ts";

/**
 * The timeline text renderer row (`timeline[row].text` / `timeline[column].text`): paints
 * its source row's text per column.
 */
export class TimelineTextRow extends RendererRow {
  get source(): SourceRow {
    const p = this.parent;
    if (!(p instanceof SourceRow)) {
      throw new Error(
        `TimelineTextRow: parent of ${this.id.rawId} is not a SourceRow ` +
          `(got ${p?.constructor.name ?? "undefined"}).`,
      );
    }
    return p;
  }

  peekText(date: NaiveDate.Partial): Option<string> {
    const cell = SourceCells.dates(this.source.peekCells(date.toRange()))[0];
    return cell == null ? null : (cell.value as Option<string>);
  }
}
